/**
*@title 게시글 팝업
*@date 2022-02-09
*@author 홍수희
*@desc 게시글 목록에서 아이템 클릭시 게시글 자세히 볼 수 있는 팝업창 컴포넌트
*@etc(change)
*/

import React,{useState,useEffect} from 'react';

import contItem01 from '../../images/cont_item_01_2022.svg';

import '../../css/board.css'

const PostModal = ({tabName, closePopup,post}) => {
    const [toggle,setToggle] = useState(false);
    useEffect(()=>{
        if(post != null){
            setToggle(true);
        }else{
            setToggle(false);
        }
    },[post])
    return(
        <section className="section-2">
            <div className="sect-01">
                <div className="close-btn">
                    <button className="close" onClick={closePopup}>x</button>
                </div>
                <div className="cont-01">
                    <div className="post-tit"><h3><span>{tabName}</span></h3></div>
                    <div><img src={contItem01}/></div>
                </div>
                {toggle ?
                    <div className="cont-02">
                        <p> {post.title} </p>
                        <p> {post.writer} </p>
                        <p> {post.created_at.slice(0,10)} </p>
                    </div>
                    :
                    <div className="cont-02">
                        <div>알 수 없음</div>
                        <div>알 수 없음</div>
                        <div>0000-00-00</div>
                        <div>null</div>
                    </div>
                }

                {toggle ? <div><div className="cont-04">{post.contents}</div><div className='cont-04'>{post.eng_contents}</div></div>:<div>비어 있음</div>}
                <div className="close-btn">
                    <button className="menu" onClick={closePopup}>목록</button>
                </div>
            </div>
        </section>

    )
}

export default PostModal;